module.exports = __webpack_public_path__ + "img/img42.2d75ad4e.jpg";